import {
  SpaceBetween,
  Box,
  TextContent,
  ColumnLayout,
  FormField,
  Select,
  Input,
} from "@cloudscape-design/components-themed";
import { isEqual, isNil } from "lodash";
import {  useState } from "react";
import {
  ConfirmationMerchantInfoItem,
  ConfirmResult,
} from "../../../features/api-interfaces";
import { getMessage } from "../../../features/error/messages";
import { isHalfNumberValid } from "../../../utils/inputValidation";
import {
  CONFIRMATION_RESULT,
  LABELS,
  REQUIRED_INDIVIDUAL_COUNSELING_PROJECT_CONFIRMATION,
} from "../constants";
import {
  getApiConfirmationResult,
  getConfirmationResultDict,
  getIndividualHandlingReason,
} from "../util";

interface IIndividualCounselingProject {
  merchantList: ConfirmationMerchantInfoItem[];
  updateItemList: (merchantInfoList: ConfirmationMerchantInfoItem[]) => void;
  isMerchantRegistered: boolean;
  confirmResultList: ConfirmResult[];
}

/**
 * 個別取扱確認更新 加盟店
 */
const IndividualCounselingProject = (props: IIndividualCounselingProject) => {
  const {
    merchantList,
    updateItemList,
    isMerchantRegistered,
    confirmResultList,
  } = props;
  const merchant = merchantList[0];
  const isRegistered = confirmResultList.find((item) =>
    isEqual(item.individualHandlingReason, merchant.individualHandlingReason)
  )?.confirmationResult;
  const individualMerchant = getIndividualHandlingReason(
    REQUIRED_INDIVIDUAL_COUNSELING_PROJECT_CONFIRMATION,
    merchantList
  );

  const [
    individualConsultationNoErrorMsg,
    setIndividualConsultationNoErrorMsg,
  ] = useState("");
  const [
    individualConsultationBranchNoErrorMsg,
    setIndividualConsultationBranchNoErrorMsg,
  ] = useState("");

  /**
   * 個別相談-Noの入力ハンドラ.
   * @param {string} inputValue
   */
  const checkIndividualConsultationNo = (inputValue: string) => {
    if (isNil(individualMerchant)) {
      return;
    }

    updateItem({
      ...individualMerchant,
      individualConsultationNo: Number(inputValue),
    });
    const errorMsg = isHalfNumberValid(inputValue)
      ? ""
      : getMessage("KGRERR006", LABELS.INDIVIDUAL_CONSULTATION_NO).label;
    setIndividualConsultationNoErrorMsg(errorMsg);
  };

  /**
   * 個別相談-枝番の入力ハンドラ.
   * @param {string} inputValue
   */
  const individualConsultationBranchNoOnChange = (inputValue: string) => {
    if (isNil(individualMerchant)) {
      return;
    }

    updateItem({
      ...individualMerchant,
      individualConsultationBranchNo: Number(inputValue),
    });
    const errorMsg = isHalfNumberValid(inputValue)
      ? ""
      : getMessage("KGRERR006", LABELS.INDIVIDUAL_CONSULTATION_BRANCH_NO).label;
    setIndividualConsultationBranchNoErrorMsg(errorMsg);
  };

  /**
   * データ更新ハンドラ
   * @param {ConfirmationMerchantInfoItem} merchantInfo
   */
  const updateItem = (merchantInfo: ConfirmationMerchantInfoItem) => {
    const updatedList: ConfirmationMerchantInfoItem[] = merchantList.map(
      (item) =>
        isEqual(
          item.individualHandlingReason,
          merchantInfo.individualHandlingReason
        )
          ? { ...merchantInfo }
          : {
              ...item,
              confirmationResult: merchantInfo.confirmationResult,
            }
    );

    updateItemList(updatedList);
  };

  return (
    <SpaceBetween direction={"vertical"} size={"s"}>
      <SpaceBetween direction={"horizontal"} size={"s"}>
        <Box>
          <Box margin={"s"} float={"left"}>
            <TextContent>
              <h5>{LABELS.CONFIRMATION_RESULT}</h5>
            </TextContent>
          </Box>
          <ColumnLayout columns={1}>
            <FormField constraintText={LABELS.BLANK_LITTLE_LONG}>
              <Select
                selectedOption={getConfirmationResultDict(
                  merchant.confirmationResult
                )}
                options={CONFIRMATION_RESULT}
                filteringType={"none"}
                onChange={({ detail: { selectedOption } }) => {
                  updateItem({
                    ...merchant,
                    confirmationResult: getApiConfirmationResult(
                      selectedOption.value!
                    ),
                  });
                }}
                disabled={isMerchantRegistered || isRegistered}
              />
            </FormField>
          </ColumnLayout>
        </Box>
      </SpaceBetween>
      <SpaceBetween direction={"horizontal"} size={"s"}>
        <Box>
          <Box margin={"s"} float={"left"}>
            <TextContent>
              <h5>{LABELS.INDIVIDUAL_CONSULTATION_NO}</h5>
            </TextContent>
          </Box>
          <ColumnLayout columns={1}>
            <FormField
              constraintText={LABELS.BLANK_LITTLE_LONG}
              errorText={individualConsultationNoErrorMsg}
            >
              <Input
                value={String(merchant.individualConsultationNo ?? "")}
                onChange={({ detail }) =>
                  checkIndividualConsultationNo(detail.value)
                }
                disabled={
                  isMerchantRegistered ||
                  isNil(individualMerchant) ||
                  isRegistered
                }
              />
            </FormField>
          </ColumnLayout>
        </Box>
        <Box>
          <Box margin={"s"} float={"left"}>
            <TextContent>
              <h5>{LABELS.INDIVIDUAL_CONSULTATION_BRANCH_NO}</h5>
            </TextContent>
          </Box>
          <ColumnLayout columns={1}>
            <FormField
              constraintText={LABELS.BLANK_LITTLE_LONG}
              errorText={individualConsultationBranchNoErrorMsg}
            >
              <Input
                value={String(merchant.individualConsultationBranchNo ?? "")}
                onChange={({ detail }) =>
                  individualConsultationBranchNoOnChange(detail.value)
                }
                disabled={
                  isMerchantRegistered ||
                  isNil(individualMerchant) ||
                  isRegistered
                }
              />
            </FormField>
          </ColumnLayout>
        </Box>
      </SpaceBetween>
    </SpaceBetween>
  );
};

export default IndividualCounselingProject;
